export function initFilegalleryFileDownload() {

    document.querySelectorAll(".filegalleryFile").forEach(el => {
        el.addEventListener("click", (event) => {
            event.preventDefault();
            window.open(el.dataset.target, "_blank");
            return false;
        });
    });
}